module.exports = __webpack_public_path__ + "static/img/bannerNew3.043ef32.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bannerNew3.webp
// module id = otjo
// module chunks = 1